import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html'
})
export class InfoModalComponent implements OnInit {

  @Input() title: string;
  @Input() info: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
